// SideMenu.jsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Home,
  LayoutDashboard,
  Ruler,
  BarChart2,
  Tractor,
  Settings,
  FileText,
  Box
} from 'lucide-react';
import { Brain } from 'lucide-react';


const menuItems = [
  { to: '/home', label: 'Painel', icon: <Home /> },
  { to: '/dashboard', label: 'Dashboard', icon: <LayoutDashboard /> },
  { to: '/sensors', label: 'Sensores', icon: <Ruler /> },
  { to: '/analise-satelite', label: 'IA Satélite', icon: <Brain /> },
  { to: '/reports', label: 'Relatórios', icon: <BarChart2 /> },
  { to: '/farm-list', label: 'Fazendas', icon: <Tractor /> },
  { to: '/harvest-history', label: 'Histórico de Safra', icon: <FileText /> },
  { to: '/stock-control', label: 'Controle de Estoque', icon: <Box /> },
  { to: '/settings', label: 'Configuração', icon: <Settings /> },
  
];

const SideMenu = () => {
  return (
    <aside className="hidden md:flex w-56 min-h-screen bg-green-800 border-r border-green-900 flex-col p-4 space-y-4">
      <div className="text-white text-2xl font-bold mb-6 tracking-wide">
        Sense Cloud
      </div>

      {menuItems.map(({ to, label, icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            `flex items-center gap-3 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              isActive
                ? 'bg-green-600 text-white'
                : 'text-gray-200 hover:text-white hover:bg-green-700'
            }`
          }
        >
          {icon}
          {label}
        </NavLink>
      ))}
    </aside>
  );
};

export default SideMenu;
